import { Box } from '@mui/material'
import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function Notes(props: Props) {
  const {
    bulkData: { notes },
  } = props
  const texts = useTexts()

  return (
    <preview.Field label={texts.notes.label}>
      {notes === 'mixed' ? (
        <preview.MixValue />
      ) : notes.length === 0 ? (
        <preview.NullValue />
      ) : (
        <Box
          component="span"
          sx={{ display: 'block', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {notes}
        </Box>
      )}
    </preview.Field>
  )
}
